<template>
  <div class="parent-maintain">
    <img src="../assets/icons/maineinence.svg" width="100px" />
    <h1>Under Maintenance!</h1>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style scoped>
.parent-maintain {
  width: 100%;
  height: 70vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
}
</style>
